import { DataContext } from 'providers/data';
import { useEffect, useContext, useState } from 'react';

import { boardNoMercosul } from 'utils/validations';
import { ParamsCustomerCars } from 'utils/typeServices';

import Modal from 'components/views/Modals';
import Tooltip from 'components/views/Tooltip';
import Input from 'components/views/form/Input';
import { Box, Typography, Skeleton } from '@mui/material';
import ModalCustomerCard from 'components/views/ModalCustomerCard';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcCustomerCard } from 'assets/icons/ic-customer-card.svg';
import { TypographyTitle, Label, ContentDetailsVehicles, ContentCustomerCard, LinkExtermal } from './styles';

type ParamsData = {
    dataSelectedCar?: ParamsCustomerCars;
}

const DetailsVehicles = ({ dataSelectedCar }: ParamsData) => {
    const [loading, setLoading] = useState(true);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const [stepUpdatePlaque, setStepUpdatePlaque] = useState(0);
    const [plaqueMercosurPattern, setPlaqueMercosurPattern] = useState(false);
    const [showOpenModalCustomerCard, setShowOpenModalCustomerCard] = useState(false);
    const [selectedCarState, setSelectedCarState] = useState<ParamsCustomerCars>();
    const [servicoSeguradora, setServicoSeguradora] = useState(false);

    const { dataUpdatePlate, handlePostUpdatePlate } = useContext(DataContext);

    useEffect(() => {
        if (dataSelectedCar) {
            setSelectedCarState(dataSelectedCar);
            setServicoSeguradora(dataSelectedCar.CODIGO_SEGURADORA === 0 ? false : true);
            handleCheckMercosul(dataSelectedCar);

            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [dataSelectedCar]);

    useEffect(() => {
        if (dataUpdatePlate) {
            if (dataUpdatePlate.isSuccess) {
                setStepUpdatePlaque(2);
            } else {
                setStepUpdatePlaque(4);
            }
            setLoadingModal(false);
        }
    }, [dataUpdatePlate]);

    const handleUpdatePlaque = () => {
        setLoadingModal(true);

        if (selectedCarState) {
            handlePostUpdatePlate({
                token: localStorage.getItem('token')!,
                body: {
                    PlatformId: selectedCarState?.NR_PLATAFORMA,
                    PadraoMercosul: plaqueMercosurPattern,
                }
            });
        }
    }

    const handleCheckMercosul = (dataSelectedCar?: ParamsCustomerCars) => {
        if (dataSelectedCar) {
            let plaqueAux = dataSelectedCar.PLACA.replace('-', '');

            if (plaqueAux.match(boardNoMercosul)) {
                setStepUpdatePlaque(0);
            } else {
                setStepUpdatePlaque(1);
            }
        }
    }

    return (
        <Box sx={{
            paddingBottom: '1.6rem',
            borderBottom: '1px solid rgba(141, 155, 181, 0.35)'
        }}>
            <TypographyTitle>
                Dados do veículo
            </TypographyTitle>

            <ContentDetailsVehicles>
                <Box sx={{
                    display: {
                        xs: 'flex',
                        md: 'block'
                    },
                    width: {
                        xs: '100%',
                        md: '40%'
                    },
                    justifyContent: 'space-between'
                }}>
                    <Label>
                        <p className='title'>Marca</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.MARCA}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'block',
                            md: 'none'
                        },
                    }}>
                        <p className='title'>Ano</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.MODELO_ANO}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'block',
                            md: 'none'
                        },
                    }}>
                        <p className='title'>Modelo</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.MODELO}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        },
                        marginTop: '1.25rem'
                    }}>
                        <p className='title'>Chassi</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.CHASSI}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        },
                        marginTop: '1.6875rem'
                    }}
                        onClick={() => setShowOpenModalCustomerCard(true)}
                    >
                        <ContentCustomerCard>
                            <IcCustomerCard />
                            <Typography fontSize='.9375rem' fontWeight={600}>
                                Cartão do cliente
                            </Typography>
                        </ContentCustomerCard>
                    </Label>
                </Box>

                <Box sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between'
                }}>
                    <Label sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        },
                    }}>
                        <p className='title'>Ano</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.MODELO_ANO}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        },
                    }}>
                        <p className='title'>Modelo</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.MODELO}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'block',
                            md: 'none'
                        },
                        marginTop: '1.25rem'
                    }}>
                        <p className='title'>Chassi</p>
                        <p className='description'>
                            {loading ? <Skeleton /> : selectedCarState?.CHASSI}
                        </p>
                    </Label>

                    <Label sx={{
                        display: 'block',
                        marginTop: {
                            xs: '1.25rem',
                            md: 0
                        }
                    }}>
                        <p className='title'>Cor</p>
                        <p className='description'>
                            {selectedCarState?.COR}
                        </p>
                    </Label>

                    <Label sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        }
                    }}>
                        <p className='title'>Placa</p>
                        <Box
                            sx={{
                                maxWidth: '6.31rem',
                                paddingTop: '.4rem',
                                '#box-input': {
                                    height: '2.2rem',
                                    marginBottom: '.375rem',
                                    'input': {
                                        height: '1.9375rem',
                                        padding: '4px 0 0 10px',
                                        '&.Mui-disabled': {
                                            color: selectedCarState?.FL_CONSULTA_PLACA ? 'rgba(0, 0, 0, 0.38)' : '#0C1C33',
                                            WebkitTextFillColor: selectedCarState?.FL_CONSULTA_PLACA ? 'rgba(0, 0, 0, 0.38)' : '#0C1C33',
                                        }
                                    },
                                    '.MuiOutlinedInput-notchedOutline': {
                                        border: '2px solid #8D9BB5'
                                    }
                                }
                            }}>
                            <Input name='' placeholder={selectedCarState?.PLACA || ''} type='text' disabled={true} />
                            <ButtonOutlined name='ATUALIZAR' disabled={selectedCarState?.FL_CONSULTA_PLACA} onClick={() => setIsOpenModal(true)} />
                        </Box>
                        {selectedCarState?.FL_CONSULTA_PLACA &&
                            <Typography fontSize='.8175rem' fontWeight={400} paddingTop='.75rem' sx={{ display: { xs: 'none', md: 'block' } }}>
                                Solicitação em análise
                            </Typography>
                        }
                    </Label>
                </Box>

                <Box sx={{
                    display: {
                        xs: 'flex',
                        md: 'none'
                    },
                    width: '100%',
                    marginTop: {
                        xs: '1.6875rem',
                        md: '0'
                    },
                    justifyContent: 'space-between',
                    flexDirection: 'row-reverse'
                }}>
                    <Label sx={{
                        display: {
                            xs: 'block',
                            md: 'block'
                        },
                        marginTop: '1.6875rem'
                    }}
                        onClick={() => setShowOpenModalCustomerCard(true)}
                    >
                        <ContentCustomerCard>
                            <IcCustomerCard />
                            <Typography fontSize='.9375rem' fontWeight={600}>
                                Cartão do cliente
                            </Typography>
                        </ContentCustomerCard>
                    </Label>

                    <Label>
                        <p className='title'>Placa</p>
                        <Box
                            sx={{
                                maxWidth: '6.31rem',
                                paddingTop: '.4rem',
                                '#box-input': {
                                    height: '2.2rem',
                                    marginBottom: '.375rem',
                                    'input': {
                                        height: '1.9375rem',
                                        padding: '4px 0 0 10px'
                                    }
                                },
                            }}>
                            <Input name='' placeholder={selectedCarState?.PLACA || ''} type='text' disabled={true} />
                            <ButtonOutlined name='ATUALIZAR' onClick={() => setIsOpenModal(true)} />
                        </Box>
                    </Label>
                </Box>
            </ContentDetailsVehicles>

            <Modal open={isOpenModal} handleClick={() => setIsOpenModal(false)}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23rem' } }}>
                    <Box sx={{ padding: '2.125rem 1.25rem 2.56rem', borderRadius: '8px 8px 0 0', textAlign: 'center' }}>
                        {stepUpdatePlaque !== 4 &&
                            <Typography variant='h5' fontWeight={700} paddingBottom='1rem'>
                                {stepUpdatePlaque === 0 ?
                                    'ATUALIZAÇÃO DE PLACA!' :
                                    stepUpdatePlaque === 1 ?
                                        'IMPORTANTE!' :
                                        stepUpdatePlaque === 2 ?
                                            'SUCESSO!' : 'ALTERAÇÃO REALIZADA!'
                                }
                            </Typography>
                        }
                        {stepUpdatePlaque === 4 &&
                            <Typography fontSize='1.25rem' lineHeight='24px' padding='0 2rem'>
                                <strong>
                                    Não foi possível concluir o <br />
                                    processo no momento.
                                </strong>
                                <br />
                                Tente novamente mais tarde.
                            </Typography>
                        }
                        {stepUpdatePlaque === 0 ?
                            <Typography fontSize='1rem'>
                                Para darmos continuidade ao processo de <br />
                                atualização precisamos saber:
                                <br />
                                <br />
                                <strong>A sua placa atual já está no padrão Mercosul?</strong>
                                <Tooltip>
                                    <Typography variant='body2' color="inherit" lineHeight='13px'>
                                        A placa contém sete dígitos, <br />
                                        adotando quatro letras e <br />
                                        três números.
                                    </Typography>
                                    <Typography fontSize='.625rem' color="inherit" fontWeight={600}
                                        sx={{
                                            width: 'fit-content',
                                            marginTop: '.5rem',
                                            borderRadius: '4px',
                                            padding: '6px 6px 5px',
                                            border: '2px solid #FFFFFF'
                                        }}>
                                        AAA1A11
                                    </Typography>
                                </Tooltip>
                            </Typography> :
                            stepUpdatePlaque === 1 ?
                                <Typography fontSize='1rem' lineHeight='20px'>
                                    Para a inserção ou atualização da sua placa,
                                    nosso sistema fará uma busca de acordo com o <b>chassi do veículo</b>,
                                    ou seja, você <br />
                                    <b>não precisará digitar a nova placa.</b><br />
                                    Mais conforto e rapidez para você!
                                    <br />
                                    <br />
                                    <strong>O prazo para a alteração é de 24 horas.</strong>
                                </Typography> :
                                stepUpdatePlaque === 2 ?
                                    <Typography fontSize='1rem' lineHeight='20px'>
                                        Em breve a sua solicitação será atendida.

                                        {servicoSeguradora &&
                                            <>
                                                <br />
                                                <br />
                                                <strong>Importante:</strong> após a correção em seu cadastro
                                                Ituran, enviaremos a alteração para a sua
                                                seguradora na <strong>próxima renovação.</strong>
                                                <br />
                                                <br />
                                                Caso queira antecipar esta alteração com a sua
                                                seguradora entre em contato:
                                            </>
                                        }
                                    </Typography>
                                    : stepUpdatePlaque === 3 &&
                                    <Typography fontSize='1rem' lineHeight='20px'>
                                        Em breve a sua solicitação será atendida.
                                    </Typography>
                        }
                    </Box>
                    <Box
                        sx={{
                            padding: '2.125rem 3rem 2.56rem',
                            backgroundColor: 'primary.main',
                            borderRadius: '0 0 8px 8px',
                            'button': {
                                width: '100%',
                                height: '2.5rem',
                                '&#btn-outlined': {
                                    borderColor: '#F9FCFF',
                                    color: '#F9FCFF',
                                    marginTop: '1rem'
                                }
                            }
                        }}>
                        {stepUpdatePlaque === 2 && servicoSeguradora &&
                            <>
                                <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem' lineHeight='1.3'>
                                    Atendimento de Segunda à Sexta das 08h as 18h e aos Sábados das 8h às 14h
                                </Typography>
                                <LinkExtermal href="tel:08007742000">
                                    0800 774 2000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                                <LinkExtermal href="tel:551136169000">
                                    3616 - 9000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            </>
                        }
                        <ButtonRectangle
                            name={stepUpdatePlaque === 0 ? 'SIM' :
                                stepUpdatePlaque === 1 ? 'ATUALIZAR' :
                                    stepUpdatePlaque === 3 ? 'CONTINUAR' : 'FECHAR'}
                            onClick={() =>
                                stepUpdatePlaque === 0 ? (setStepUpdatePlaque(1), setPlaqueMercosurPattern(true)) :
                                    stepUpdatePlaque === 1 ? handleUpdatePlaque() : setIsOpenModal(false)}
                            loadingBtn={loadingModal}
                        />

                        {stepUpdatePlaque < 2 &&
                            <ButtonOutlined
                                name={stepUpdatePlaque === 0 ? 'NÃO' : 'CANCELAR'}
                                onClick={() => stepUpdatePlaque === 0 ? (setStepUpdatePlaque(1), setPlaqueMercosurPattern(false)) : (handleCheckMercosul(selectedCarState), setIsOpenModal(false))} />
                        }
                    </Box>
                </Box>
            </Modal>
            <ModalCustomerCard open={showOpenModalCustomerCard} handleClick={(e) => setShowOpenModalCustomerCard(e)} />
        </Box>
    );
}

export default DetailsVehicles;